module.exports = __webpack_public_path__ + "static/client7-dd5bbbeec8987b7039f74be507013062.png";